module.exports = __webpack_public_path__ + "static/media/footer_ico_consulting.b35425a1.svg";